import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Dialog from '@mui/material/Dialog';
import Link from '@mui/material/Link'
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { fetchPrivacyPolicy } from "../../reducers/privacy_policy";
import { Box, Skeleton, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";

const PrivacyPolicy = (props) => {
    const { user: currentUser, groupGuid:groupGuid } = useSelector((state) => state.auth);
    const [ open, setOpen ] = useState(false)
    const [searchParams] = useSearchParams();

    const PPstatus = useSelector(state => state.privacypolicy.status)
    const viewInstance = useSelector(state => state.privacypolicy.entities)
    const globcon = useSelector((state) => state.contexts.entities)

    const dispatch = useDispatch()

    useEffect(() => {
      if(PPstatus === "idle" && (searchParams.get("g") || groupGuid) ){
        dispatch(fetchPrivacyPolicy({ GroupGuid: searchParams.get("g") || groupGuid, LanguageId: globcon?.LanguageId || -1 }))
      }
    },[PPstatus,searchParams,groupGuid])

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    if(viewInstance.PrivacyPolicyPage){
      return (
        <Box>
          
          <Typography variant="body2" sx={{ "&:hover": { textDecoration:"underline",cursor: "pointer" } }} onClick={handleClickOpen}> {viewInstance.PrivacyPolicyPage.PrivacyPolicyFooterText}</Typography>
          
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{viewInstance.PrivacyPolicyPage.PrivacyPolicyFooterText}</DialogTitle>
            <DialogContent>
              <DialogContentText style={{wordWrap:"break-word"}} dangerouslySetInnerHTML={{__html: viewInstance.PrivacyPolicyPage.PrivacyPolicyBody}}>
              </DialogContentText>

            </DialogContent>
          </Dialog>
        </Box> 
      )
    } else {
      return (
        <Box>
          
         <Link variant="inherit" underline="always">
            Privacy Policy
          </Link>
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
              <Skeleton variant="text" width={150} />
            </DialogTitle>
            <DialogContent>
              <DialogContentText style={{wordWrap:"break-word"}}>
                <Skeleton variant="rounded" width={200} height={300}/>
              </DialogContentText>
            </DialogContent>
          </Dialog>

        </Box>
      )
    }
  
};

export default PrivacyPolicy;